import { ReactNode } from 'react'

import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { Form } from '../../Form/index.js'
import { T } from '../../i18n/index.js'

const LabelWithTooltip = ({
  label,
  tooltip,
}: {
  label: ReactNode
  tooltip: ReactNode
}) => {
  return (
    <div className="flex items-center gap-2">
      {label}
      <Tooltip>
        <Tooltip.Trigger>
          <SvgIcon name="info" />
        </Tooltip.Trigger>
        <Tooltip.Panel>{tooltip}</Tooltip.Panel>
      </Tooltip>
    </div>
  )
}

export const NotificationSettings = () => {
  return (
    <Accordion variant="chevron" iconAlign="trailing">
      <Accordion.Button>
        <T
          id="Event.Form.NotificationSettings"
          defaultMessage="Notification settings"
        />
      </Accordion.Button>
      <Accordion.Panel>
        <div className="grid grid-cols-[1fr_1fr] gap-2">
          <Form.Toggle
            togglePosition="start"
            groupClassName="!justify-normal"
            name="notificationSettings.notifyOnRegister"
            label={
              <LabelWithTooltip
                label={
                  <T
                    id="Event.Form.NotificationSettings.NotifyOnRegister"
                    defaultMessage="Notify on register"
                  />
                }
                tooltip={
                  <T
                    id="Event.Form.NotifyRegistration.Tooltip"
                    defaultMessage="Send an email and in-app notification to attendees when they register for the event."
                  />
                }
              />
            }
          />
          <Form.Toggle
            togglePosition="start"
            groupClassName="!justify-normal"
            name="notificationSettings.notifyOnDelete"
            label={
              <LabelWithTooltip
                label={
                  <T
                    id="Event.Form.NotificationSettings.NotifyOnDelete"
                    defaultMessage="Notify on delete"
                  />
                }
                tooltip={
                  <T
                    id="Event.Form.NotifyDeletion.Tooltip"
                    defaultMessage="Send an email and in-app notification to all registered attendees when the event is deleted."
                  />
                }
              />
            }
          />
          <Form.Toggle
            togglePosition="start"
            groupClassName="!justify-normal"
            name="notificationSettings.notifyOnUpdate"
            label={
              <LabelWithTooltip
                label={
                  <T
                    id="Event.Form.NotificationSettings.NotifyOnUpdate"
                    defaultMessage="Notify on update"
                  />
                }
                tooltip={
                  <T
                    id="Event.Form.NotifyUpdate.Tooltip"
                    defaultMessage="Send an email and in-app notification to attendees when the event details are updates (such as date, time, location, etc.)."
                  />
                }
              />
            }
          />
          <Form.Toggle
            togglePosition="start"
            groupClassName="!justify-normal"
            name="notificationSettings.remindBefore"
            label={
              <LabelWithTooltip
                label={
                  <T
                    id="Event.Form.NotificationSettings.SendReminder.Title"
                    defaultMessage="Send reminder"
                  />
                }
                tooltip={
                  <T
                    id="Event.Form.NotificationSettings.SendReminder.Tooltip"
                    defaultMessage="Send a reminder email and in-app notification to attendees shortly before the event starts."
                  />
                }
              />
            }
          />
        </div>
      </Accordion.Panel>
    </Accordion>
  )
}
